import * as ActionTypes from "@mds/common/constants/actionTypes";
/* eslint-disable import/prefer-default-export */
export const storeEpicInfo = (payload) => ({
  type: ActionTypes.STORE_MINE_EPIC_INFO,
  payload,
});
